export const CHECK_AUTH = "checkAuth"
export const LOGIN = "login"
export const LOGOUT = "logout"
export const REGISTER = "signup"
